import { render, staticRenderFns } from "./dealRevenue.vue?vue&type=template&id=6097ad08&scoped=true"
import script from "./dealRevenue.vue?vue&type=script&lang=js"
export * from "./dealRevenue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6097ad08",
  null
  
)

export default component.exports